import router from "@/router";
import store from "@/store";
import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule
} from "vuex-module-decorators";

import { accountService } from "@/app/services/AccountService";
import { getFcmToken } from "@/utils/firebase";
import { Message } from "@/types/fcm/message";
import { deviceModule } from "@/store/device";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "fcmMessage"
})
class FcmMessageModule extends VuexModule {
  fcmMessages: Message[] = [];
  hasPermission = false;

  get activeFcmMessage() {
    if (this.fcmMessages.length === 0) {
      return null;
    }
    return this.fcmMessages[0];
  }

  @Mutation
  CLEAR_FCM_MESSAGE(fcmMessage: Message) {
    this.fcmMessages = this.fcmMessages.filter(
      v => v.type_id !== fcmMessage.type_id
    );
  }

  /**
   * 運営からのチャットに関するメッセージを取得した際の処理
   * @param state
   * @param message
   */
  @Mutation
  ON_RECEIVED_XXX(fcmMessage: Message) {
    // フォアグラウンドかバックグラウンドかで処理を切り分け
    if (fcmMessage.tap === "background") {
      // 該当画面に移動
      router.push({ name: "sample" });
    } else {
      this.fcmMessages.push(fcmMessage);
    }
  }

  @Mutation
  CHECK_PERMISSION() {
    // @ts-ignore
    FirebasePlugin.hasPermission(hasPermission => {
      this.hasPermission = hasPermission;
    });
  }

  /**
   * FCMトークンをサーバーに送る
   * ログインしていない場合も実行されるが、サーバーにはアクセスされない
   */
  @Action
  async sendFcmToken() {
    // @ts-ignore
    if (window.FirebasePlugin === undefined) {
      console.warn("skipped: sendFcmToken");
      return;
    }
    console.log("FIREBASE PLUGIN sendFcmToken start------------------");
    try {
      const fcmToken = await getFcmToken();
      const platform = deviceModule.platform;
      const appVersion = deviceModule.versionNo;
      if (fcmToken) {
        accountService.registerDeviceToken(fcmToken, platform, appVersion);
      }
      console.log("FIREBASE PLUGIN sendFcmToken end------------------");
    } catch (error) {
      // 通知を拒否した場合や、選択しないまま一定時間経過した場合などは、トークンが取得できずエラーになる
      // ユーザーの選択によるものなので、Sentry への通知は行わない
      console.warn(error);
    }
  }

  @Action
  init() {
    // @ts-ignore
    if (window.FirebasePlugin === undefined) {
      console.warn("skipped: init");
      return;
    }

    console.log("FIREBASE PLUGIN init start------------------");
    this.grantPermission();
    this.sendFcmToken();
  }

  @Action
  grantPermission() {
    // @ts-ignore
    if (window.FirebasePlugin === undefined) {
      console.warn("skipped: grantPermission");
      return;
    }
    console.log("FIREBASE PLUGIN grantPermission start------------------");
    // @ts-ignore
    FirebasePlugin.grantPermission(
      (hasPermission: boolean) => {
        console.log("FIREBASE PLUGIN grantPermission end------------------");
        console.log(hasPermission);
      },
      (err: unknown) => {
        console.log("grantPermission errro!", JSON.stringify(err));
      }
    );
  }
}

export const fcmMessageModule = getModule(FcmMessageModule);
